module.exports = __webpack_public_path__ + "static/media/logo-wellhub.e9c1d504.svg";